import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './project-member.types';

export const projectTeamSelectors = {
  ...generateResourceSelectors<types.IProjectTeam>((state) => state.resource.projectTeam),
};
